import React from 'react';
import { FormattedMessage } from 'react-intl';
import SearchViewContainer from './containers/SearchViewContainer';

export default {
  path: 'haku',
  name: <FormattedMessage id="search_title" />,
  components: { content: SearchViewContainer }
};
